// because these exist in purchasing and shop apps, respectively, we're wrapping them for testing purposes

// @ts-ignore
// eslint-disable-next-line import/no-unresolved
import getAxiosInstance, { TOKEN_KEY } from 'app/config/api';

// @ts-ignore
// eslint-disable-next-line import/no-unresolved
import datalayer from 'app/datalayer';

export { TOKEN_KEY, getAxiosInstance, datalayer };
